export default {};
/**
 * @description Месяцы.
 * @type {string[]}
 */
const month = [
  'января',
  'февраля',
  'марта',
  'апреля',
  'мая',
  'июня',
  'июля',
  'августа',
  'сентября',
  'ноября',
  'декабря',
];

export function padTo4Digits(num) {
  return num.toString().padStart(4, '0');
}
/**
 * @description Вставить в начало строки нули.
 * @param {number} num
 * @returns {string}
 */
export function padTo2Digits(num) {
  return num.toString().padStart(2, '0');
}
/**
 * @description Форматировать дату.
 * @param {Date}   date
 * @param {string} separator
 * @returns {string}
 */
export function formatDate(date, separator = '.') {
  return [
    padTo2Digits(date.getDate()),
    padTo2Digits(date.getMonth() + 1),
    date.getFullYear().toString().slice(2),
  ].join(separator);
}

/**
 * @description Форматировать дату в день и месяц.
 * @param {Date} date
 * @returns {string}
 */
export function formatDateToDayAndMonth(date) {
  return [
    padTo2Digits(date.getDate()),
    padTo2Digits(date.getMonth() + 1),
  ].join('.');
}

/**
 * @description Форматировать дату в строку.
 * @param {Date} date
 * @returns {string}
 */
export function formatDateString(date) {
  return [
    padTo2Digits(date.getDate()),
    padTo2Digits(date.getMonth() + 1),
    padTo4Digits(date.getFullYear()),
  ].join('.');
}

/**
 * @description Получить время.
 * @param {Date} date
 * @returns {string}
 */
export function formatTime(date) {
  return [padTo2Digits(date.getHours()), padTo2Digits(date.getMinutes())].join(':');
}
/**
 * @description Получить строковое представление даты.
 * @param {Date} date Дата.
 * @returns {string}
 */
export function getDate(date) {
  return [padTo2Digits(date.getDate()), month[date.getMonth()], date.getFullYear()].join(' ');
}
/**
 * @description Получить представление даты для поля ввода.
 * @param {Date} date Дата.
 * @returns {string}
 */
export function convertToInputDate(date) {
  return [
    padTo4Digits(date.getFullYear()),
    padTo2Digits(date.getMonth() + 1),
    padTo2Digits(date.getDate()),
  ].join('-');
}

/**
 * @description Нормализовать дату-время iso8601 в формат даты-времени Date API.
 * @param {string} isoDate Входная дата.
 * @returns {string}
 */
export function normalizeIso8601ToDateTimeStringFormat(isoDate) {
  if (typeof isoDate !== 'string') {
    return undefined;
  }
  return isoDate.replace(
    /^([0-9]{4}-[0-9]{2}-[0-9]{2})[ T]([0-9]{2}:[0-9]{2})(:[0-9]{2})?$/,
    (_, date, hoursAndMinutes, seconds) => `${date}T${hoursAndMinutes}${seconds || ':00'}`,
  );
}
